import { render, staticRenderFns } from "./GeneralInfo.vue?vue&type=template&id=201ea314&scoped=true&"
import script from "./GeneralInfo.vue?vue&type=script&lang=ts&"
export * from "./GeneralInfo.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralInfo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GeneralInfo.vue?vue&type=style&index=1&id=201ea314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201ea314",
  null
  
)

export default component.exports